/** The current code of a check-in, as shown in its QR. Changes every 30 seconds. */
export class CheckInCode {
  constructor(
    public readonly code: string,
    /** What the QR contains: `dijkgraaf://check-in?c=<check-in uuid>&k=<code>`. */
    public readonly qrPayload: string,
    /** Seconds until the code changes (it is accepted for up to 30 seconds after that). */
    public readonly validForSeconds: number,
  ) {}

  static fromJson(json: any): CheckInCode {
    return new CheckInCode(
      json["code"],
      json["qr_payload"],
      json["valid_for_seconds"]
    );
  }
}
